import React from 'react';
import styled from 'styled-components';
import { FlexMiddle, FlexColumnCenter } from '@ubeya/shared-web/components';
import { media } from '@ubeya/shared-web/style';
import { EmptyState as DefaultEmptyState } from 'shared/components';
import { EmptyStateButton } from 'shared/components';

const ButtonWrapper = styled(FlexMiddle)`
  flex-direction: column;
  gap: 20px;

  ${media.mobile`
  flex-direction: row;
  `}
`;
const Wrapper = styled(FlexColumnCenter)`
  flex: 1;

  .empty-state-wrapper {
    width: 426px;
  }
`;

export const ButtonedEmptyState = ({ Icon, text, subText, buttons = [] }) => {
  return (
    <Wrapper>
      <DefaultEmptyState Icon={Icon} text={text} subText={subText}>
        {buttons.length && (
          <ButtonWrapper>
            {buttons.map(({ link, Icon: ButtonIcon, type, text: buttonText, onClick }, index) => (
              <EmptyStateButton
                key={index}
                link={link}
                Icon={ButtonIcon}
                text={buttonText}
                onClick={onClick}
                type={type}
              />
            ))}
          </ButtonWrapper>
        )}
      </DefaultEmptyState>
    </Wrapper>
  );
};
